module.exports = __webpack_public_path__ + "assets/img/1.fc583bc2.jpg";